/**
 * Created by Ning Jiang on 3/13/2020.
 */
import {MultiSprites} from "@nolimitcity/slot-game/bin/core/displayobject/MultiSprites";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TweenLite} from "gsap";

export class MultiplierPageContainer extends PIXI.Container {

    private readonly _numberStyle:any = {
        fontName : "TotalMultipliers",
        fontSize : 15,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    private _background:MultiSprites;
    private _textsContainer:PIXI.Container;
    private _xText:PIXI.BitmapText;
    private _numberText:PIXI.BitmapText;

    private _maxWidth:number = 110;

    constructor() {
        super();

        this._background = new MultiSprites({
            normal : {
                textures : GameResources.getTextures("multiplierPosterNormal"),
                anchor : [0.53, 0.44]
            },
            freespin : {
                textures : GameResources.getTextures("multiplierPosterFS"),
                anchor : [0.53, 0.44]
            },
            normal_landing : {
                textures : GameResources.getTextures("multiplierLandingNormal"),
                anchor : [0.53, 0.44] // TODO:
            },
            freespin_landing : {
                textures : GameResources.getTextures("multiplierLandingFS"),
                anchor : [0.53, 0.44] // TODO:
            },
            normal_drag : {
                textures : GameResources.getTextures("multiplierDragNormal"),
                anchor : [0.53, 0.44] // TODO:
            },
            freespin_drag : {
                textures : GameResources.getTextures("multiplierDragFS"),
                anchor : [0.53, 0.44] // TODO:
            },
            dagger_drag : {
                textures : GameResources.getTextures("multiplierDragDagger"),
                anchor : [0.53, 0.44] // TODO:
            },
        });
        this.addChild(this._background);

        this._textsContainer = new PIXI.Container();
        this._textsContainer.rotation = 0.19;
        this.addChild(this._textsContainer);

        this._xText = new PIXI.BitmapText("x", this._numberStyle);
        this._xText.letterSpacing = -15;
        (<PIXI.Point>this._xText.anchor).set(0.5, 0.5);
        this._textsContainer.addChild(this._xText);

        this._numberText = new PIXI.BitmapText("1", this._numberStyle);
        this._numberText.letterSpacing = -15;
        (<PIXI.Point>this._numberText.anchor).set(0.5, 0.5);
        this._textsContainer.addChild(this._numberText);
    }

    public updateMultiplier(number:number, state:string):void {
        this._numberText.text = `${number}`;
        this.organize();
        this._background.playSpriteFrames(state, {
                duration : 0,
                vars : [{toVars : {alpha : 1}}]
            },
            {
                duration : 0,
                vars : [{toVars : {alpha : 0}}]
            });
    }

    public popMultiplier(delay:number):void {
        TweenLite.fromTo(this._xText.scale, 0.2, {x : 0.5, y : 0.5}, {x : 1, y : 1, delay : delay});
    }

    private organize():void {
        let scale:number = 1;
        this._numberText.updateTransform();
        const totalWidth:number = this._xText.textWidth + this._numberText.textWidth;
        this._xText.x = -totalWidth * 0.5 + this._xText.textWidth * 0.5;
        this._numberText.x = -totalWidth * 0.5 + this._xText.textWidth + this._numberText.textWidth * 0.5;
        while(totalWidth * scale > this._maxWidth) {
            scale -= 0.01;
        }
        this._textsContainer.scale.set(scale);
    }
}